import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { QualityScoresClient, qualityScoresApiRef } from './api';
import { rootRouteRef } from './routes';

export const scoresPlugin = createPlugin({
  id: 'scores',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: qualityScoresApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: deps => QualityScoresClient.create(deps),
    }),
  ],
});

export const ScoresPage = scoresPlugin.provide(
  createRoutableExtension({
    name: 'ScoresPage',
    component: () => import('./components/ScoresPage').then(m => m.ScoresPage),
    mountPoint: rootRouteRef,
  }),
);

export const EntityScoresCard = scoresPlugin.provide(
  createComponentExtension({
    name: 'EntityScoresCard',
    component: {
      lazy: () =>
        import('./components/EntityScoresCard').then(m => m.EntityScoresCard),
    },
  }),
);

export const EntityQualityScoreCard = scoresPlugin.provide(
  createComponentExtension({
    name: 'EntityQualityScoreCard',
    component: {
      lazy: () =>
        import('./components/EntityQualityScoreCard').then(
          m => m.EntityQualityScoreCard,
        ),
    },
  }),
);
